export enum FinancePlanConstant {
  KESKVALITSUS = 'KESKVALITSUS',
  KOV_YKSUS = 'KOV_YKSUS',
  KOV = 'KOV'
}

